import {
  Button,
  Modal,
  Text,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Spinner,
} from "@chakra-ui/react";
import { string } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../redux/Store";
interface IdeleteData {
  rootId: string;
  _id: string;
  isOpen: boolean;
  onClose: () => void;
  deleteFunc: (rootId: string, reviewId: string) => {};
}
function DeleteReviewModal(props: IdeleteData) {
  const dispatch = useDispatch();
  const uiState = useSelector((state: RootStore) => state.ui);
  const handleDel = () => {
    dispatch(props.deleteFunc(props.rootId, props._id));
  };
  useEffect(() => {
    if (uiState.loading === false) {
      props.onClose();
    }
  }, [uiState.loading]);
  return (
    <>
      <Modal
        blockScrollOnMount={true}
        isOpen={props.isOpen}
        onClose={props.onClose}
        isCentered
        colorScheme="red"
        motionPreset="slideInBottom"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Review</ModalHeader>
          <ModalBody>
            <Text fontWeight="bold" mb="1rem">
              Are you sure to delete this review?
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
              id="DeleteButton"
              isLoading={uiState.loading}
              loadingText={"Deleting"}
              onClick={handleDel}
            >
              Yes
            </Button>
            <Button
              colorScheme="red"
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
              onClick={props.onClose}
              id="CancelButton"
            >
              No
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
export default DeleteReviewModal;
